import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemQuantitySelector =
  (bomItemId: string, preferTreeView?: boolean) =>
  (state: RootAppState): number => {
    if (!state.project.activeProject) {
      return null
    }

    if (bomItemId === state.project?.activeProject?.id) {
      return state.project.activeProject.financial.quantity
    }

    const bomItem = bomItemSelector(state, bomItemId, preferTreeView)

    switch (bomItem?.type) {
      case 'MaterialHeader':
        return bomItem.cuttingPlans.reduce((acc, cp) => acc + cp.quantity, 0)
      case 'Assembly':
      case 'Row':
        return bomItem.financial.quantity
      case 'RoutingHeader':
        return 0
    }
  }
